import { deepCopy, currency } from '_u/helper'

// 序列化租约信息
export function formateLease(lease) {
    lease.priceRemark = lease.priceRemark || ''
    lease.unitPrice = lease.unitPrice ? multiply(lease.unitPrice) : 0
    lease.rent = lease.rent ? multiply(lease.rent) : 0
    lease.deposit = lease.deposit ? multiply(lease.deposit) : 0
    lease.addAmount = lease.addAmount ? multiply(lease.addAmount) : 0
    lease.leftAmount = lease.leftAmount ? multiply(lease.leftAmount) : 0
    lease.resAmount = lease.resAmount ? multiply(lease.resAmount) : 0

    if (lease.depositOffset && lease.depositOffset.length) {
        lease.depositOffset = lease.depositOffset[0]
    } else {
        lease.depositOffset = ''
    }

    lease.increase.forEach((v) => {
        if (v.numerical === '') {
            v.numerical = 0
        } else if (v.increaseWay === 1) {
            v.numerical /= 100
        } else if (v.increaseWay === 2) {
            v.numerical = multiply(v.numerical)
        }
    })

    // 租金优惠格式化
    const discount = []
    if (lease.discount.length) {
        lease.discountType = lease.discount[0][0]
        lease.discount.shift()
    } else {
        lease.discountType = ''
    }
    if (lease.discountType === '2') {
        lease.discount.forEach((v) => (v.amount = multiply(v.amount)))
    }

    // 数据筛选
    lease.discount.forEach((v) => {
        // 按合同月优惠
        if (lease.discountType == '3') {
            if (v.period && v.month) {
                discount.push(v)
            }
        } else {
            // 移除没有开始日期与结束日期项
            if (v.startDate && v.endDate) {
                discount.push(v)
            }
        }
    })
    lease.discount = discount
    lease.otherFee = lease.otherFee.filter(
        (v) => v.feeType && v.chargeWay && v.amount
    )
    lease.otherFee.forEach((v) => (v.amount = multiply(v.amount)))
    lease.otherDeposit = lease.otherDeposit.filter((v) => v.feeType && v.amount)
    lease.otherDeposit.forEach((v) => (v.amount = multiply(v.amount)))

    lease.receiveRentType = lease.rentDay.receiveRentType
    lease.receiveRentValue = lease.rentDay.receiveRentValue

    lease.increase = JSON.stringify(lease.increase)
    lease.discount = JSON.stringify(lease.discount)
    lease.otherFee = JSON.stringify(lease.otherFee)
    lease.otherDeposit = JSON.stringify(lease.otherDeposit)
}

// 反序列化租约
export function formateLeaseReverse(lease) {
    lease.priceRemark = lease.priceRemark || ''
    lease.unitPrice = lease.unitPrice ? lease.unitPrice / 100 : 0
    lease.rent = lease.rent ? lease.rent / 100 : 0
    lease.deposit = lease.deposit ? lease.deposit / 100 : 0
    lease.addAmount = lease.addAmount ? lease.addAmount / 100 : 0
    lease.leftAmount = lease.leftAmount ? lease.leftAmount / 100 : 0
    lease.resAmount = lease.resAmount ? lease.resAmount / 100 : 0
    lease.deposit += lease.leftAmount

    lease.depositOffset = lease.depositOffset ? [lease.depositOffset] : []

    lease.increase = lease.increase ? JSON.safeParse(lease.increase) : []
    lease.discount = lease.discount ? JSON.safeParse(lease.discount) : []
    lease.otherFee = lease.otherFee ? JSON.safeParse(lease.otherFee) : []
    lease.otherDeposit = lease.otherDeposit
        ? JSON.safeParse(lease.otherDeposit)
        : []

    // 筛选金额大于0的
    lease.increase = lease.increase.filter((v) => v.numerical > 0)

    lease.increase.forEach((v) => {
        if (v.increaseWay === 1) {
            v.numerical = multiply(v.numerical)
        } else if (v.increaseWay === 2) {
            v.numerical /= 100
        }
    })

    if (lease.discountType === '2') {
        lease.discount.forEach((v) => (v.amount /= 100))
    }
    lease.otherFee.forEach((v) => (v.amount /= 100))
    lease.otherDeposit.forEach((v) => (v.amount /= 100))
}

// 合同提交、合同预览格式化合并
export function formateContractAndView(data) {
    data.cus.cusType = data.cus.cusType[0]
    if (data.cus.cusId === data.cus.cusName) {
        data.cus.cusId = ''
    }
    data.contract.signUser = data.lease.signUser
    // 添加物品清单
    data.facility = []
    data.lease.fList.fList.forEach((v) => {
        v.price = multiply(v.price)
        v.remark = data.lease.fList.remark
        data.facility.push(v)
    })
    formateLease(data.lease)
    delete data.lease.fList
}

// 增加定金抵租押金文字
export function getResAmountText(bill, isWrap = true, isShowPrice = true) {
    let billStr = ''
    const str = isWrap ? '\r\n' : ''
    const price = isShowPrice ? `：${currency(bill.offsetAmount / 100)}` : ''
    if (bill.depositOffset === '1') {
        billStr = `${str}(定抵押${price})`
    } else if (bill.depositOffset === '2') {
        billStr = `${str}(定抵租${price})`
    }
    return billStr
}

// 渲染账单金额
export function renderBillAmountText(h, obj, el, elSon) {
    // 如果账单数据没有更改，使用renderAmountText把（）内的文字变为红色
    // 否则，把内容全部变为紫色#6300BF
    if (obj.update == 0) {
        return renderAmountText(h, obj.amount, el, elSon)
    }

    const newList = []
    obj.amount.forEach((v) => {
        newList.push(h(elSon, { style: { color: '#6300BF' } }, v))
    })
    return h(el, newList)
}

// 渲染函数
export function renderAmountText(h, list, el, elSon) {
    const newList = []
    list.forEach((v) => {
        const index = v.indexOf('(')
        if (index > -1) {
            newList.push(h(elSon, { style: { color: 'red' } }, v))
        } else {
            newList.push(h(elSon, v))
        }
    })
    return h(el, newList)
}

// 读数清算初始化
export function initExpenseSettlement(res, expenseSettlement) {
    const list = res.data.list
    list.forEach((v) => {
        v.planAmount /= 100
        v.realAmount /= 100
        v.resAmountText = getResAmountText(v, true, false)
        // 未收/应收
        if (v.billStatus === '1' || v.billStatus === '6') {
            v.amount = v.planAmount
            v.receivables = v.planAmount
            v.refund = 0
            v.isReceive = '1'
        }

        // 已收
        if (v.billStatus === '2') {
            v.amount = v.planAmount
            v.receivables = 0
            v.refund = v.planAmount
            v.isReceive = '2'
        }

        // 未付/应付
        if (v.billStatus === '3' || v.billStatus === '7') {
            v.amount = v.planAmount
            v.receivables = 0
            v.refund = v.planAmount
            v.isReceive = '2'
        }

        // 已付
        if (v.billStatus === '4') {
            v.amount = v.planAmount
            v.receivables = v.planAmount
            v.refund = 0
            v.isReceive = '1'
        }
    })
    expenseSettlement.list = list
}

// 格式化合同参数-读数清算
export function formateMeterSettlement(meterSettlement) {
    const list = deepCopy(meterSettlement)
    list.forEach((v) => {
        v.price = multiply(v.price)
        v.amount = multiply(v.amount)
    })
    return list
}

// 格式化合同参数-费用清算
export function formateExpenseSettlement(expenseSettlementList) {
    const list = deepCopy(expenseSettlementList)
    list.forEach((v) => {
        v.amount = multiply(v.amount)
        v.receivables = multiply(v.receivables)
        v.refund = multiply(v.refund)
        v.planAmount = multiply(v.planAmount)
    })
    return list
}

// 费用清算总金额
export function chargeDetailsTotal(list) {
    list = deepCopy(list)
    const inPrice = list.find((v) => v.title === '实际收款费用')
    const outPrice = list.find((v) => v.title === '实际退款费用')
    const meter = list.find((v) => v.title === '抄表费用')
    const inPriceList = inPrice ? inPrice.list : []
    const outPriceList = outPrice ? outPrice.list : []
    const meterList = meter ? meter.list : []
    let total = 0
    inPriceList.forEach((v) => {
        v.forEach((p) => {
            total += multiply(strToNum(p.val))
        })
    })
    outPriceList.forEach((v) => {
        v.forEach((p) => {
            total -= multiply(strToNum(p.val))
        })
    })
    meterList.forEach((v) => {
        total += multiply(strToNum(v[4]))
    })
    return currency(total / 100) + '元'
}

// 乘以100
export function multiply(num, mul = 100) {
    return parseInt((num * 100).toFixed(0))
}

// 金额字符串转为Number类型 "1,000.00"->1000.00 "1,000.00元"->1000.00
export function strToNum(str) {
    const arr = str.split('')
    const exp = /[0-9]|\.|\-|\+/
    let newStr = ''
    arr.forEach((v) => {
        if (exp.test(v)) {
            newStr += v
        }
    })
    return parseFloat(newStr)
}
